import { Avatar } from '@efexteam/components';
import { Box, Card, CardContent, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { UpdateBeneficiaryServiceResponse } from '@pages/approveBeneficiary/types';
import BeneficiaryCardStyles from './BeneficiaryCard.styles';

interface BeneficiaryCardProps {
  beneficiaryData: UpdateBeneficiaryServiceResponse;
}

const DetailRow = ({ label, value }: { label: string; value: string }) => (
  <Box className={BeneficiaryCardStyles.detailRow}>
    <Typography variant="body2" color="text.secondary">
      {label}:
    </Typography>
    <Typography variant="body2" className={BeneficiaryCardStyles.detailValue}>
      {value}
    </Typography>
  </Box>
);

const BeneficiaryCard = ({ beneficiaryData }: BeneficiaryCardProps) => {
  const { t } = useTranslation();

  return (
    <Card className={BeneficiaryCardStyles.card}>
      <CardContent className={BeneficiaryCardStyles.cardContent}>
        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
          className={BeneficiaryCardStyles.headerStack}
        >
          <Avatar size="lg" username={beneficiaryData.legalName} />
          <Box className={BeneficiaryCardStyles.avatarContainer}>
            <Typography variant="h6">{beneficiaryData.legalName}</Typography>
            <Typography variant="body2" color="text.secondary">
              {t('appBnfCompany')}
            </Typography>
          </Box>
        </Stack>

        {beneficiaryData.legalName && (
          <DetailRow
            label={t('appBnfLegalName')}
            value={beneficiaryData.legalName}
          />
        )}
        {beneficiaryData.email && (
          <DetailRow label={t('appBnfEmail')} value={beneficiaryData.email} />
        )}
        {beneficiaryData.country && (
          <DetailRow
            label={t('appBnfCountry')}
            value={beneficiaryData.country}
          />
        )}
        {beneficiaryData.address && (
          <DetailRow
            label={t('appBnfAddress')}
            value={beneficiaryData.address}
          />
        )}
        {beneficiaryData.phone && (
          <DetailRow label={t('appBnfPhone')} value={beneficiaryData.phone} />
        )}
        {beneficiaryData.transactionType && (
          <DetailRow
            label={t('appBnfTransactionType')}
            value={beneficiaryData.transactionType}
          />
        )}
        {beneficiaryData.bankName && (
          <DetailRow
            label={t('appBnfBankName')}
            value={beneficiaryData.bankName}
          />
        )}
        {beneficiaryData.accountNumber && (
          <DetailRow
            label={t('appBnfAccountNumber')}
            value={beneficiaryData.accountNumber}
          />
        )}
        {beneficiaryData.routingNumber && (
          <DetailRow
            label={t('appBnfRoutingNumber')}
            value={beneficiaryData.routingNumber}
          />
        )}
        {beneficiaryData.accountType && (
          <DetailRow
            label={t('appBnfAccountType')}
            value={beneficiaryData.accountType}
          />
        )}
      </CardContent>
    </Card>
  );
};

export default BeneficiaryCard;
